import React from 'react'
import AnchorLink from '../AnchorLink'
import Curve from '../charts/Curve'
import Line from '../charts/Line'
const TeamRankings =({
  title = 'Team Rankings',
  subtitle = '',
  isAllTop = false,
  charts = [],
  link = {
    title : 'Full Statistics',
    href : '#',
    external: true
  },
  teamColor = ''
}) => {
  const target = link.external ? { target: '_blank' } : {}
  const Header = `${title}<span>${subtitle} </span>`
  const TeamRankingsModule = !charts.length ? <article className="sub-module"></article> :
  (
    <article className = "sub-module rankings alt">
      <header>
        <h1 dangerouslySetInnerHTML={{ __html: Header }}>
        </h1>
      </header>
      <div className="content">
        <ul>
        {
          charts.map((c, i) => {
            return <Chart {...c} key={i} isAllTop={isAllTop} teamColor={teamColor} />
          })
        }          
        </ul>
      </div>
      {
        link.href && link.title &&
        <footer>
          <AnchorLink trackingName={link.trackingName} to={link.href} text={link.title} {...target} />
        </footer>
      }
    </article>
  )
  return TeamRankingsModule
}


const Chart = ({
  heading = '',
  subHeading = '',
  chartType,
  isOnlyMax = false,
  isTied = false,
  isAllTop = false,
  homeTeam = {},
  awayTeam = {},
  statName = '',
  teamColor = ''
}) => {
  const props = {
    heading,
    subHeading,
    chartType,
    isOnlyMax,
    isTied,
    homeTeam,
    awayTeam,
    teamColor
  }
  let logo = ''
  let rank = `1<sup>st</sup> <span>${homeTeam.stats || awayTeam.stats} ${statName}</span>`
  rank = (statName == 'points' && isAllTop) ? `= ${rank}` : rank
  let isChartRequired = true
  if(isOnlyMax) {    
    logo = homeTeam.teamLogo || ''
    isChartRequired = false
  }
  else if(isTied) {
    logo = awayTeam.teamLogo || ''    
    isChartRequired =false
  }
  if(isChartRequired) {
    return (
      <li>
        <ChartHeading {...props}/>
        {
          chartType == 'curve' ?  <CurveChart {...props} /> : <LineChart {...props} />
        }
      </li>
    )
  }
  else {
    return(
      <li>
        <ChartHeading {...props}/>  
        <img data-default-src={ logo } className="team-logo lazyload" data-src={ logo } />
        <div className="rank" dangerouslySetInnerHTML={{ __html : rank }}>
        </div>
      </li>
    )
  }
}

const ChartHeading = ({
  homeTeam = {},
  awayTeam = {},
  heading = '',
  subHeading = '',
  isOnlyMax = false,
  teamColor =''
}) => {
  const subHeadingMarkup = subHeading ? `<span>${subHeading}</span>` : ''
  const headingMarkup = [ heading || '', subHeadingMarkup ].join(' ')
  const titleMarkup = <div className="title" dangerouslySetInnerHTML={{ __html : headingMarkup }}></div>
  if(isOnlyMax) {
    return ( titleMarkup )
  }
  else {
    return (
    <div className="chart-header">
      <Team className="team-a" abbrev={homeTeam.abbreviation} rankMarkup={homeTeam.rankMarkup} isHomeTeam={true} key="teama" teamColor={teamColor}/>
      {titleMarkup}
      <Team className="team-b" abbrev={awayTeam.abbreviation} rankMarkup={awayTeam.rankMarkup} isHomeTeam={false} key="teamb"/>
    </div>
    )
  }  
}


const Team = ({
  className = '',
  abbrev = '',
  rankMarkup = '',
  isHomeTeam = false,
  teamColor = ''
}) => {
  const color = {
    background : isHomeTeam ? teamColor : '#dddddd'
  }
  return (
    <div className={className}>
      <span className="bar" style={color}></span>
      <span className="short-name">{abbrev}</span>
      <span className="rank" dangerouslySetInnerHTML={{ __html: rankMarkup }}></span>
    </div>
    )
}


const CurveChart = ({
homeTeam = {},
awayTeam = {},
teamColor =''
}) => {
  const homeTeamWidth = Math.abs(Math.ceil(homeTeam.stats/awayTeam.stats*100)) || 2  
  const homeColor = { color : teamColor }
  const awayColor = { color : '#dddddd' }
  return (
    <div className="half-chart">
      <Curve className="team-a" arcWidth={homeTeamWidth} color={homeColor} value={homeTeam.stats}/>
      <Curve className="team-b" arcWidth={awayTeam.stats>0? 100 : 2} color={awayColor} value={awayTeam.stats}/>      
    </div>
    )
}
const LineChart = ({
  homeTeam = {},
  awayTeam = {},
  teamColor =''
}) => {
  let absHomeVal = Math.abs(homeTeam.stats)
  let absAwayVal = Math.abs(awayTeam.stats)
  let maxVal = Math.max(absHomeVal, absAwayVal)
  let homeBarStyle = { background : teamColor, width : Math.ceil(absHomeVal*50/maxVal) || 3 }
  let awayBarStyle = { background : '#dddddd', width : Math.ceil(absAwayVal*50/maxVal) || 3 }
  return (
    <div className="bar-chart">
      <Line className="team team-a" value={homeTeam.stats} style={homeBarStyle}/>
      <Line className="team team-b" value={awayTeam.stats} style={awayBarStyle}/>
    </div>
  )
}
export default TeamRankings



/** WEBPACK FOOTER **
 ** ../app/components/common/col-c/TeamRankings.jsx
 **/